/* ==========================================================================
   BEUTE.STUDIO — prada.js · ein Skript für alles.
   Schichten (Menü/Suche/Warenkorb/Filter), Klappen, Reiter, Karussells mit
   Fortschrittsbalken, Produktseite, Filterblende, Größenwahl, Empfehlungen und
   Hinweisleiste des Warenkorbs, Countdown der Passwortseite. Texte kommen aus #prada-texte (Theme-Einstellungen).
   Bewegung: nur transform/opacity, Austritt schneller als Eintritt, unter 300 ms.
   Tastatur-Aktionen ohne Animation. Der Theme-Editor rendert Sektionen neu —
   deshalb initialisiert `starten(wurzel)` alles auch nachträglich.
   ========================================================================== */
(function () {
  'use strict';

  var d = document, w = window, de = d.documentElement;
  var reduziert = w.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  function geld(cent) { return (cent / 100).toFixed(2).replace('.', ',') + ' €'; }
  function schuetzen(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function drossel(fn) {
    var laeuft = false;
    return function () {
      if (laeuft) return;
      laeuft = true;
      w.requestAnimationFrame(function () { laeuft = false; fn(); });
    };
  }

  /* Texte aus den Theme-Einstellungen; Rückfall, falls das JSON fehlt */
  var T = {
    leerTitel: 'Noch nichts drin.', leerText: 'Jedes Stück gibt es genau einmal — wer zögert, verpasst.',
    leerKnopf: 'Stücke ansehen', leerZiel: '/collections/all', entfernen: 'Entfernen', gr: 'Gr.',
    hinzu: 'Hinzufügen', hinzugefuegt: 'Hinzugefügt', fehler: 'Das hat nicht geklappt. Bitte noch einmal versuchen.',
    empfAn: true, empfTitel: 'Passt dazu', empfText: 'In deiner Größe, sofort lieferbar.',
    suchNichts: 'Nichts gefunden für', suchFehler: 'Die Suche ist gerade nicht erreichbar.', suchAlle: 'Alle Ergebnisse',
    suchUrl: '/search', grHinweis: 'Gefiltert nach deiner Größe', grAendern: 'Alle Größen anzeigen',
    versandFrei: 'Versand kostenlos', versandNoch: 'Noch {betrag} bis zum kostenlosen Versand'
  };
  try {
    var tj = d.getElementById('prada-texte');
    if (tj) { var geladen = JSON.parse(tj.textContent); Object.keys(geladen).forEach(function (k) { if (geladen[k] != null && geladen[k] !== '') T[k] = geladen[k]; }); }
  } catch (e) { /* Rückfall bleibt */ }

  var HAKEN = '<svg class="ico" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';

  de.classList.remove('no-js');
  de.classList.add('js');
  de.classList.add('js-bereit');

  /* ========================================================================
     1 — SCHICHTEN: eine Stelle sperrt das Blättern, eine Stelle schaltet den Grund
     ======================================================================== */
  var offen = null;
  var scrollMerk = 0;
  var DAUER_AUS = 220;

  function grundSperren() {
    scrollMerk = w.scrollY;
    d.body.style.top = '-' + scrollMerk + 'px';
    d.body.classList.add('ist-gesperrt');
  }
  function grundFreigeben() {
    d.body.classList.remove('ist-gesperrt');
    d.body.style.top = '';
    w.scrollTo(0, scrollMerk);
  }

  function schichtOeffnen(id, ausloeser) {
    var el = d.getElementById(id);
    if (!el) return;
    if (offen === id) return;
    korbLeisteWeg();
    var warOffen = !!offen;
    if (offen) schichtSchliessen(true);
    offen = id;
    if (ausloeser) ausloeser.setAttribute('data-zuletzt-geoeffnet', '');
    el.hidden = false; void el.offsetWidth; el.classList.add('auf');
    var g = d.getElementById('grund-schleier');
    if (g) { g.hidden = false; void g.offsetWidth; g.classList.add('auf'); }
    if (!warOffen) grundSperren();
    $$('[aria-controls="' + id + '"]').forEach(function (k) { k.setAttribute('aria-expanded', 'true'); });
    w.setTimeout(function () {
      var ziel = el.querySelector('[data-fokus]') || el.querySelector('button, a, input');
      if (ziel) ziel.focus({ preventScroll: true });
    }, 60);
    if (id === 'korb-blende') empfehlungenLaden();
  }

  function schichtSchliessen(sofort) {
    if (!offen) return;
    var id = offen;
    offen = null;
    var el = d.getElementById(id);
    var g = d.getElementById('grund-schleier');
    if (el) {
      el.classList.remove('auf');
      if (sofort) { el.hidden = true; }
      else { w.setTimeout(function () { if (offen !== id) el.hidden = true; }, DAUER_AUS); }
    }
    if (g) {
      g.classList.remove('auf');
      if (sofort) { g.hidden = true; }
      else { w.setTimeout(function () { if (!offen) g.hidden = true; }, DAUER_AUS); }
    }
    $$('[aria-controls="' + id + '"]').forEach(function (k) { k.setAttribute('aria-expanded', 'false'); });
    if (!sofort) grundFreigeben();
    var auf = d.querySelector('[data-zuletzt-geoeffnet]');
    if (auf) { auf.removeAttribute('data-zuletzt-geoeffnet'); if (!sofort) auf.focus({ preventScroll: true }); }
  }

  d.addEventListener('click', function (e) {
    var k = e.target.closest('[data-schicht-auf]');
    if (k) {
      e.preventDefault();
      var id = k.getAttribute('data-schicht-auf');
      offen === id ? schichtSchliessen() : schichtOeffnen(id, k);
      return;
    }
    if (e.target.closest('[data-schliessen]') || e.target.id === 'grund-schleier') {
      e.preventDefault();
      schichtSchliessen();
    }
  });
  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && offen) schichtSchliessen();
  });
  d.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !offen) return;
    var el = d.getElementById(offen);
    if (!el) return;
    var f = $$('a[href], button:not([disabled]), input, select, textarea', el)
      .filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var erste = f[0], letzte = f[f.length - 1];
    if (e.shiftKey && d.activeElement === erste) { e.preventDefault(); letzte.focus(); }
    else if (!e.shiftKey && d.activeElement === letzte) { e.preventDefault(); erste.focus(); }
  });

  /* ========================================================================
     2 — KLAPPEN (Akkordeon): Höhe wird gemessen, nicht geraten
     ======================================================================== */
  function klappe(k, tastatur) {
    var ziel = d.getElementById(k.getAttribute('aria-controls'));
    if (!ziel) return;
    var auf = k.getAttribute('aria-expanded') === 'true';
    k.setAttribute('aria-expanded', auf ? 'false' : 'true');
    var sofort = tastatur || reduziert;
    if (auf) {
      if (sofort) { ziel.style.height = '0px'; ziel.hidden = true; return; }
      ziel.classList.add('zu');
      ziel.style.height = ziel.scrollHeight + 'px';
      void ziel.offsetWidth;
      ziel.style.height = '0px';
      ziel.addEventListener('transitionend', function ab() {
        ziel.hidden = true; ziel.classList.remove('zu');
        ziel.removeEventListener('transitionend', ab);
      });
    } else {
      ziel.hidden = false;
      if (sofort) { ziel.style.height = 'auto'; return; }
      ziel.style.height = '0px';
      void ziel.offsetWidth;
      ziel.style.height = ziel.scrollHeight + 'px';
      ziel.addEventListener('transitionend', function ab() {
        ziel.style.height = 'auto';
        ziel.removeEventListener('transitionend', ab);
      });
    }
  }
  d.addEventListener('click', function (e) {
    var k = e.target.closest('[data-klappe]');
    if (!k) return;
    e.preventDefault();
    klappe(k, e.detail === 0);
  });

  /* ========================================================================
     3 — REITER (Tabs)
     ======================================================================== */
  function reiterWaehlen(knopf, tastatur) {
    var wurzel = knopf.closest('[data-reiter-wurzel]');
    if (!wurzel) return;
    var id = knopf.getAttribute('data-reiter');
    $$('[data-reiter]', wurzel).forEach(function (r) {
      var an = r === knopf;
      r.setAttribute('aria-selected', an ? 'true' : 'false');
      r.setAttribute('tabindex', an ? '0' : '-1');
    });
    $$('[data-reiter-panel]', wurzel).forEach(function (p) {
      var an = p.getAttribute('data-reiter-panel') === id;
      if (an && p.hidden) {
        p.hidden = false;
        if (!tastatur && !reduziert) {
          p.classList.add('kommt');
          p.addEventListener('animationend', function ab() { p.classList.remove('kommt'); p.removeEventListener('animationend', ab); });
        }
      } else if (!an) {
        p.hidden = true; p.classList.remove('kommt');
      }
    });
    w.dispatchEvent(new Event('prada:layout'));
  }
  d.addEventListener('click', function (e) {
    var r = e.target.closest('[data-reiter]');
    if (!r) return;
    e.preventDefault();
    reiterWaehlen(r, e.detail === 0);
  });
  d.addEventListener('keydown', function (e) {
    var r = e.target.closest('[data-reiter]');
    if (!r || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    var alle = $$('[data-reiter]', r.closest('[data-reiter-wurzel]'));
    var i = alle.indexOf(r) + (e.key === 'ArrowRight' ? 1 : -1);
    if (i < 0 || i >= alle.length) return;
    e.preventDefault();
    alle[i].focus();
    reiterWaehlen(alle[i], true);
  });

  /* ========================================================================
     4 — KARUSSELL: Fortschrittsbalken (Breite = sichtbarer Anteil), Pfeile am PC
     ======================================================================== */
  var karussells = [];
  function karussellStarten(el) {
    if (el.dataset.karussellBereit === '1') return;
    el.dataset.karussellBereit = '1';
    var spur = el.querySelector('[data-spur]');
    var balken = el.querySelector('[data-balken]');
    var segmente = $$('[data-segment]', el);
    var zurueck = el.querySelector('[data-zurueck]');
    var weiter = el.querySelector('[data-weiter]');
    if (!spur) return;
    function stand() {
      var breite = spur.scrollWidth, sicht = spur.clientWidth, x = spur.scrollLeft;
      if (!breite || !sicht) return;
      var anteil = Math.min(1, sicht / breite);
      /* Passt alles ins Bild (z. B. drei Stücke am PC), wird die Spur mittig gesetzt und die Pfeile verschwinden */
      el.classList.toggle('karussell--passt', anteil >= 0.999);
      if (balken) {
        balken.style.transform = 'translateX(' + ((x / breite) * 100).toFixed(3) + '%) scaleX(' + anteil.toFixed(4) + ')';
        balken.parentNode.hidden = anteil >= 0.999;
      }
      if (segmente.length) {
        var i = Math.round(x / sicht);
        segmente.forEach(function (s, j) { s.classList.toggle('ist-aktiv', j === i); });
      }
      if (zurueck) zurueck.disabled = x <= 2;
      if (weiter) weiter.disabled = x + sicht >= breite - 2;
    }
    spur.addEventListener('scroll', drossel(stand), { passive: true });
    if (zurueck) zurueck.addEventListener('click', function () { spur.scrollBy({ left: -spur.clientWidth * 0.8, behavior: reduziert ? 'auto' : 'smooth' }); });
    if (weiter) weiter.addEventListener('click', function () { spur.scrollBy({ left: spur.clientWidth * 0.8, behavior: reduziert ? 'auto' : 'smooth' }); });
    karussells.push(stand);
    stand();
    /* Automatisch weiterschalten (Bild-Karussell): pausiert beim Zeigen, Berühren, Fokus, im Hintergrund-Tab */
    var lauf = parseInt(el.getAttribute('data-lauf') || '0', 10);
    if (lauf > 0 && !reduziert) {
      var pausiert = false;
      ['pointerenter', 'touchstart', 'focusin'].forEach(function (ev) { el.addEventListener(ev, function () { pausiert = true; }, { passive: true }); });
      ['pointerleave', 'touchend', 'touchcancel', 'focusout'].forEach(function (ev) { el.addEventListener(ev, function () { pausiert = false; }, { passive: true }); });
      w.setInterval(function () {
        if (pausiert || d.hidden) return;
        var sicht = spur.clientWidth, max = spur.scrollWidth - sicht;
        if (max <= 2) return;
        var ziel = spur.scrollLeft >= max - 2 ? 0 : Math.min(spur.scrollLeft + sicht, max);
        spur.scrollTo({ left: ziel, behavior: 'smooth' });
      }, lauf);
    }
  }
  function karussellsMessen() { karussells.forEach(function (f) { f(); }); }
  w.addEventListener('resize', drossel(karussellsMessen));
  w.addEventListener('prada:layout', function () { w.setTimeout(karussellsMessen, 20); });
  w.addEventListener('load', karussellsMessen);

  /* ========================================================================
     6 — SUCHE
     ======================================================================== */
  (function suche() {
    var abbruch = null, warte = null;
    d.addEventListener('input', function (e) {
      var feld = e.target.closest('[data-such-feld]');
      if (!feld) return;
      var wort = feld.value.trim();
      var raum = d.getElementById('such-treffer');
      if (!raum) return;
      w.clearTimeout(warte);
      if (wort.length < 2) { raum.innerHTML = ''; raum.dataset.zustand = 'leer'; return; }
      raum.dataset.zustand = 'laedt';
      warte = w.setTimeout(function () {
        if (abbruch) abbruch.abort();
        abbruch = new AbortController();
        var url = T.suchUrl + '/suggest.json?q=' + encodeURIComponent(wort) + '&resources[type]=product&resources[limit]=6';
        fetch(url, { signal: abbruch.signal })
          .then(function (r) { return r.json(); })
          .then(function (j) {
            var tr = (j.resources && j.resources.results && j.resources.results.products) || [];
            if (!tr.length) {
              raum.dataset.zustand = 'nichts';
              raum.innerHTML = '<p class="such-nichts">' + schuetzen(T.suchNichts) + ' „' + schuetzen(wort) + '".</p>';
              return;
            }
            raum.dataset.zustand = 'treffer';
            raum.innerHTML = tr.map(function (p) {
              var bild = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
              var preis = p.price != null && String(p.price).length
                ? (isNaN(parseFloat(p.price)) ? p.price : parseFloat(p.price).toFixed(2).replace('.', ',') + ' €') : '';
              return '<a class="such-treffer" href="' + schuetzen(p.url) + '">' +
                (bild ? '<img src="' + schuetzen(bild) + '&width=120" alt="" width="48" height="60">' : '<span class="such-treffer__ph"></span>') +
                '<span class="such-treffer__text">' +
                  '<span class="such-treffer__marke">' + schuetzen(p.vendor || '') + '</span>' +
                  '<span class="such-treffer__name">' + schuetzen(p.title) + '</span>' +
                '</span>' +
                '<span class="such-treffer__preis">' + schuetzen(preis) + '</span>' +
              '</a>';
            }).join('') +
            '<a class="such__alle textlink" href="' + schuetzen(T.suchUrl) + '?type=product&q=' + encodeURIComponent(wort) + '">' + schuetzen(T.suchAlle) + '</a>';
          })
          .catch(function (err) {
            if (err && err.name === 'AbortError') return;
            raum.dataset.zustand = 'nichts';
            raum.innerHTML = '<p class="such-nichts">' + schuetzen(T.suchFehler) + '</p>';
          });
      }, 180);
    });
  })();

  /* ========================================================================
     7 — GRÖSSEN: Hilfen für Karten, Warenkorb und Empfehlungen
     ======================================================================== */
  var GROESSEN = ['XS', 'S', 'M', 'L', 'XL', '2XL', 'XXL', '3XL', 'XXXL'];
  function groesseVon(text) {
    var t = String(text || '').toUpperCase().trim();
    if (GROESSEN.indexOf(t) < 0) return null;
    if (t === 'XXL') return '2XL';
    if (t === 'XXXL') return '3XL';
    return t;
  }
  function produktGroessen(p) {
    var s = [];
    (p.variants || []).forEach(function (v) {
      [v.option1, v.option2, v.option3].forEach(function (o) { var g = groesseVon(o); if (g && s.indexOf(g) < 0) s.push(g); });
    });
    (p.tags || []).forEach(function (t) {
      var m = /^groesse-(.+)$/i.exec(String(t)); if (m) { var g = groesseVon(m[1]); if (g && s.indexOf(g) < 0) s.push(g); }
    });
    return s;
  }
  function gruppeVon(typ, titel) {
    var t = (String(typ || '') + ' ' + String(titel || '')).toLowerCase();
    if (/jacke|jacket|windbreaker|anorak|weste|mantel|parka/.test(t)) return 'jacke';
    if (/hose|short|jogg|pants|track|jeans|cargo/.test(t)) return 'unten';
    return 'oben';
  }

  /* Meine Größe: einmal wählen, überall zuerst passende Stücke sehen */
  var SCHLUESSEL = 'beute_groesse';
  function meineGroesse() { try { return groesseVon(localStorage.getItem(SCHLUESSEL)) || ''; } catch (e) { return ''; } }
  function groesseMerken(g) { try { g ? localStorage.setItem(SCHLUESSEL, g) : localStorage.removeItem(SCHLUESSEL); } catch (e) { /* privat */ } }

  function groessenAnwenden() {
    var g = meineGroesse();
    $$('[data-groessen-filter]').forEach(function (wurzel) {
      var sichtbar = 0;
      $$('[data-sizes]', wurzel).forEach(function (k) {
        var passt = !g || (k.getAttribute('data-sizes') || '').indexOf('|' + g + '|') > -1;
        k.hidden = !passt;
        if (passt) sichtbar++;
      });
      var leer = wurzel.querySelector('[data-groessen-leer]');
      if (leer) leer.hidden = !g || sichtbar > 0;
    });
    $$('[data-groesse-chip]').forEach(function (c) { c.classList.toggle('groesse--gewaehlt', (c.getAttribute('data-groesse-chip') || '') === g); c.setAttribute('aria-pressed', (c.getAttribute('data-groesse-chip') || '') === g ? 'true' : 'false'); });
    w.dispatchEvent(new Event('prada:layout'));
  }
  d.addEventListener('click', function (e) {
    var c = e.target.closest('[data-groesse-chip]');
    if (!c) return;
    e.preventDefault();
    var g = groesseVon(c.getAttribute('data-groesse-chip')) || '';
    groesseMerken(g === meineGroesse() ? '' : g);   /* zweiter Klick hebt die Wahl auf */
    groessenAnwenden();
  });

  /* ========================================================================
     8 — WARENKORB: Inhalt steht beim ersten Öffnen schon im Markup
     ======================================================================== */
  var letzterKorb = null;
  function zahlSetzen(n, hüpfen) {
    $$('[data-korb-zahl]').forEach(function (b) {
      b.textContent = n; b.hidden = n < 1;
      if (hüpfen && !reduziert) { b.classList.remove('pop'); void b.offsetWidth; b.classList.add('pop'); }
    });
  }
  function versandSetzen(korb) {
    var el = d.getElementById('korb-versand');
    if (!el) return;
    var grenze = parseInt(el.dataset.grenze || '0', 10);
    if (grenze <= 0) return;
    var rest = grenze - korb.total_price;
    var band = el.querySelector('.korb-versand__fuell');
    if (band) band.style.transform = 'scaleX(' + Math.min(1, korb.total_price / grenze).toFixed(3) + ')';
    var txt = el.querySelector('.korb-versand__text');
    if (txt) txt.textContent = rest <= 0 ? T.versandFrei : T.versandNoch.replace('{betrag}', geld(rest));
  }
  function korbGroesse(p) {
    var g = null;
    (p.variant_options || []).forEach(function (o) { g = g || groesseVon(o); });
    (p.options_with_values || []).forEach(function (o) { g = g || groesseVon(o.value); });
    return g;
  }
  function zeichnen(korb, hüpfen) {
    letzterKorb = korb;
    zahlSetzen(korb.item_count, hüpfen);
    versandSetzen(korb);
    var fuss = d.getElementById('korb-fuss');
    var liste = d.getElementById('korb-liste');
    var einzel = d.getElementById('korb-einzel');
    if (einzel) einzel.hidden = !korb.item_count;
    if (!liste) return;
    if (!korb.item_count) {
      liste.innerHTML =
        '<div class="korb-leer">' +
          '<p class="korb-leer__wort">' + schuetzen(T.leerTitel) + '</p>' +
          '<p class="korb-leer__satz">' + schuetzen(T.leerText) + '</p>' +
          '<a class="knopf knopf--rand" href="' + schuetzen(T.leerZiel) + '">' + schuetzen(T.leerKnopf) + '</a>' +
        '</div>';
      if (fuss) fuss.hidden = true;
      $$('[data-korb-empfehlungen]').forEach(function (e0) { e0.hidden = true; e0.innerHTML = ''; });
      return;
    }
    if (fuss) fuss.hidden = false;
    liste.innerHTML = korb.items.map(function (p) {
      var bild = p.featured_image && p.featured_image.url
        ? '<img class="korb-stueck__bild" src="' + schuetzen(p.featured_image.url) + '&width=200" alt="" width="72" height="90">'
        : '<span class="korb-stueck__bild korb-stueck__bild--ph"></span>';
      var g = korbGroesse(p);
      var variante = g ? '<p class="korb-stueck__var">' + schuetzen(T.gr) + ' ' + schuetzen(g) + '</p>'
        : ((p.variant_title && p.variant_title !== 'Default Title') ? '<p class="korb-stueck__var">' + schuetzen(p.variant_title) + '</p>' : '');
      var marke = p.vendor && String(p.product_title || '').toLowerCase().indexOf(String(p.vendor).toLowerCase()) === -1
        ? '<p class="korb-stueck__marke">' + schuetzen(p.vendor) + '</p>' : '';
      return '<article class="korb-stueck" data-schluessel="' + schuetzen(p.key) + '">' +
        '<a class="korb-stueck__bildlink" href="' + schuetzen(p.url) + '">' + bild + '</a>' +
        '<div class="korb-stueck__text">' + marke +
          '<a class="korb-stueck__name" href="' + schuetzen(p.url) + '">' + schuetzen(p.product_title) + '</a>' +
          variante +
          '<div class="korb-stueck__reihe">' +
            '<span class="korb-stueck__preis">' + geld(p.final_line_price != null ? p.final_line_price : p.line_price) + '</span>' +
            '<button class="korb-stueck__weg" type="button" data-korb-weg="' + schuetzen(p.key) + '">' + schuetzen(T.entfernen) + '</button>' +
          '</div>' +
        '</div>' +
      '</article>';
    }).join('');
    var summe = d.getElementById('korb-summe');
    if (summe) summe.textContent = geld(korb.total_price);
    empfehlungenLaden(true);
  }
  function holen(pfad, daten) {
    return fetch(pfad, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(daten)
    }).then(function (r) { return r.json(); });
  }
  function korbLaden() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }

  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-korb-weg]');
    if (!b) return;
    e.preventDefault();
    var stueck = b.closest('.korb-stueck');
    if (stueck) stueck.classList.add('geht');
    holen('/cart/change.js', { id: b.getAttribute('data-korb-weg'), quantity: 0 })
      .then(function (k) { zeichnen(k, false); })
      .catch(function () { if (stueck) stueck.classList.remove('geht'); });
  });

  /* ========================================================================
     8b — HINWEIS NACH „IN DEN WARENKORB“
     Fest am oberen Bildschirmrand, direkt unter dem Kopf — auch wenn die Seite
     weit gescrollt ist. Bild, Titel, „Im Warenkorb“, goldener Knopf „Ansehen“,
     goldene Restzeit-Linie (pausiert beim Zeigen). Dazu fliegt das Produktbild
     zum Warenkorb-Symbol, das kurz pulsiert. Alles nur transform/opacity.
     ======================================================================== */
  var LEISTE_DAUER = 5000, leisteUhr = null, leisteLauf = null, leisteScroll = null;
  function leisteBauen(el) {
    if (el.dataset.gebaut === '1') return;
    el.dataset.gebaut = '1';
    var text = el.querySelector('[data-leiste-text]'), link = el.querySelector('.korb-leiste__link');
    var innen = d.createElement('div'); innen.className = 'korb-leiste__innen';
    var bild = d.createElement('span'); bild.className = 'korb-leiste__bild'; bild.setAttribute('data-leiste-bild', ''); bild.hidden = true;
    var haken = d.createElement('span'); haken.className = 'korb-leiste__haken'; haken.setAttribute('aria-hidden', 'true');
    haken.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
    innen.appendChild(bild); innen.appendChild(haken);
    if (text) innen.appendChild(text);
    if (link) innen.appendChild(link);
    var zeit = d.createElement('span'); zeit.className = 'korb-leiste__zeit'; zeit.setAttribute('data-leiste-zeit', ''); zeit.setAttribute('aria-hidden', 'true');
    el.innerHTML = ''; el.appendChild(innen); el.appendChild(zeit);
    /* Aus dem Kopf heraus direkt unter <body>: fester Bezug zum Bildschirm, unabhängig vom Kopf */
    d.body.appendChild(el);
    ['pointerenter', 'focusin'].forEach(function (ev) { el.addEventListener(ev, function () { if (leisteLauf) leisteLauf.pause(); w.clearTimeout(leisteUhr); }); });
    ['pointerleave', 'focusout'].forEach(function (ev) { el.addEventListener(ev, function () { if (leisteLauf) leisteLauf.play(); else leisteUhr = w.setTimeout(korbLeisteWeg, 1500); }); });
  }
  /* Direkt unter dem Kopf, solange der im Bild ist; sonst ganz oben */
  function leisteOben() {
    var el = d.getElementById('korb-leiste'), kopf = d.querySelector('[data-kopf]');
    if (!el) return;
    var oben = 0;
    if (kopf) { var r = kopf.getBoundingClientRect(); oben = Math.max(0, Math.round(r.bottom)); }
    el.style.top = oben + 'px';
  }
  function korbLeisteZeigen(titel, bildUrl) {
    var el = d.getElementById('korb-leiste');
    if (!el) return false;
    leisteBauen(el);
    var text = el.querySelector('[data-leiste-text]');
    if (text) text.innerHTML = (titel ? '<strong>' + schuetzen(titel) + '</strong>' : '') + '<span>' + schuetzen(T.leisteText) + '</span>';
    var bild = el.querySelector('[data-leiste-bild]');
    if (bild) {
      if (bildUrl) { bild.innerHTML = '<img src="' + schuetzen(bildUrl) + '" alt="" width="40" height="50">'; bild.hidden = false; }
      else { bild.innerHTML = ''; bild.hidden = true; }
    }
    leisteOben();
    if (!leisteScroll) { leisteScroll = drossel(leisteOben); w.addEventListener('scroll', leisteScroll, { passive: true }); w.addEventListener('resize', leisteScroll); }
    el.hidden = false; void el.offsetWidth; el.classList.add('auf');
    w.clearTimeout(leisteUhr);
    if (leisteLauf) { leisteLauf.cancel(); leisteLauf = null; }
    var zeit = el.querySelector('[data-leiste-zeit]');
    if (zeit && zeit.animate && !reduziert) {
      leisteLauf = zeit.animate([{ transform: 'scaleX(1)' }, { transform: 'scaleX(0)' }], { duration: LEISTE_DAUER, easing: 'linear', fill: 'forwards' });
      leisteLauf.onfinish = function () { var a = leisteLauf; leisteLauf = null; korbLeisteWeg(); if (a) a.cancel(); };
    } else {
      leisteUhr = w.setTimeout(korbLeisteWeg, LEISTE_DAUER);
    }
    return true;
  }
  function korbLeisteWeg() {
    var el = d.getElementById('korb-leiste');
    if (!el || !el.classList.contains('auf')) return;
    el.classList.remove('auf');
    w.clearTimeout(leisteUhr);
    if (leisteLauf) { leisteLauf.cancel(); leisteLauf = null; }
    w.setTimeout(function () { if (!el.classList.contains('auf')) el.hidden = true; }, DAUER_AUS);
  }

  /* Warenkorb-Symbol: Zahl hüpft, goldener Ring läuft einmal aus */
  function korbPuls() {
    var knopf = d.querySelector('[data-kopf] [data-schicht-auf="korb-blende"]');
    if (!knopf || reduziert) return;
    knopf.classList.remove('puls'); void knopf.offsetWidth; knopf.classList.add('puls');
    w.setTimeout(function () { knopf.classList.remove('puls'); }, 700);
  }
  /* Produktbild fliegt zum Warenkorb-Symbol (Web Animations, nur transform/opacity) */
  function flugZumKorb(quelle) {
    var ziel = d.querySelector('[data-kopf] [data-schicht-auf="korb-blende"]');
    if (!quelle || !ziel || reduziert || !quelle.animate) return Promise.resolve();
    var q = quelle.getBoundingClientRect(), z = ziel.getBoundingClientRect();
    if (!q.width || !q.height || !z.width || z.bottom < 0 || z.top > w.innerHeight) return Promise.resolve();
    var klon = d.createElement('img');
    klon.src = quelle.currentSrc || quelle.src; klon.alt = ''; klon.className = 'korb-flug';
    klon.style.left = q.left + 'px'; klon.style.top = q.top + 'px'; klon.style.width = q.width + 'px'; klon.style.height = q.height + 'px';
    d.body.appendChild(klon);
    var dx = (z.left + z.width / 2) - (q.left + q.width / 2), dy = (z.top + z.height / 2) - (q.top + q.height / 2);
    var mass = Math.max(0.06, Math.min(0.2, 28 / Math.max(q.width, q.height)));
    var lauf = klon.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1, offset: 0 },
      { transform: 'translate(' + (dx * 0.5) + 'px,' + (dy * 0.5 - 40) + 'px) scale(' + ((1 + mass) / 2) + ')', opacity: 1, offset: 0.55 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + mass + ')', opacity: 0.25, offset: 1 }
    ], { duration: 560, easing: 'cubic-bezier(.77,0,.175,1)', fill: 'forwards' });
    return new Promise(function (fertig) {
      lauf.onfinish = function () { klon.remove(); fertig(); };
      lauf.oncancel = function () { klon.remove(); fertig(); };
      w.setTimeout(function () { if (klon.parentNode) klon.remove(); fertig(); }, 900);
    });
  }
  function bildQuelle(form) {
    var wurzel = form.closest('[data-produkt]') || form.closest('.karte') || form.closest('article');
    if (!wurzel) return null;
    var bilder = $$('img', wurzel).filter(function (i) { var r = i.getBoundingClientRect(); return r.width > 20 && r.height > 20 && r.bottom > 0 && r.top < w.innerHeight; });
    return bilder[0] || null;
  }

  /* Erfolg am Knopf: kurz „Hinzugefügt“ mit Haken, dann zurück */
  function erfolgZeigen(knopf) {
    if (!knopf) return;
    var alt = knopf.innerHTML;
    knopf.classList.add('knopf--erfolg');
    knopf.innerHTML = HAKEN + '<span>' + schuetzen(T.hinzugefuegt) + '</span>';
    w.setTimeout(function () { knopf.classList.remove('knopf--erfolg'); knopf.innerHTML = alt; }, 1600);
  }

  /* Hinzufügen — jedes Formular, das auf /cart/add zeigt */
  d.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.getAttribute('action') || form.getAttribute('action').indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var knopf = form.querySelector('[type="submit"]');
    if (knopf) { knopf.disabled = true; knopf.classList.add('laedt'); }
    var knopfFrei = function () { if (knopf) { knopf.disabled = false; knopf.classList.remove('laedt'); } };
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Fehler'); });
        return r.json();
      })
      .then(function (stueck) { return korbLaden().then(function (korb) { return { stueck: stueck, korb: korb }; }); })
      .then(function (x) {
        knopfFrei(); erfolgZeigen(knopf);
        var st = x.stueck && x.stueck.items ? x.stueck.items[0] : x.stueck;
        var titel = st && st.product_title;
        var bildUrl = st && ((st.featured_image && st.featured_image.url) || st.image) || '';
        if (bildUrl) bildUrl += (bildUrl.indexOf('?') > -1 ? '&' : '?') + 'width=120';
        if (T.korbVerhalten === 'schublade') { zeichnen(x.korb, true); schichtOeffnen('korb-blende', knopf); return; }
        /* Bild fliegt zum Symbol, dann hüpft die Zahl; die Leiste erscheint sofort */
        var quelle = bildQuelle(form);
        if (!korbLeisteZeigen(titel, bildUrl)) { zeichnen(x.korb, true); schichtOeffnen('korb-blende', knopf); return; }
        flugZumKorb(quelle).then(function () { zeichnen(x.korb, true); korbPuls(); });
      })
      .catch(function (err) { knopfFrei(); melden(err.message === 'Fehler' ? T.fehler : err.message); });
  });

  var start = d.getElementById('korb-daten');
  if (start) zahlSetzen(parseInt(start.dataset.zahl || '0', 10), false);

  /* ========================================================================
     9 — EMPFEHLUNGEN IM WARENKORB
     Zwei feste Stücke je Warenkorb. Regel: gleiche Größe zuerst, dann das
     fehlende Teil zum Outfit (Oberteil ↔ Hose ↔ Jacke), gleiche Marke leicht
     bevorzugt; nur lieferbare Ware, nie etwas, das schon im Korb liegt.
     Die Auswahl fällt beim ersten Stück im Korb und bleibt für die Sitzung
     (sessionStorage) — nach dem Hinzufügen rückt NICHTS nach. Neu gewählt wird
     erst, wenn der Korb leer war; ein inzwischen verkauftes Stück wird einmal
     ersetzt. Quelle: Shopify-Empfehlungen zu den Stücken im Korb plus die
     lieferbare Ware. Nichts wird behauptet, was nicht da ist.
     ======================================================================== */
  var poolCache = null, empfLaeuft = false, EMPF_KEY = 'beute_empf_v2';

  function poolLaden(korb) {
    if (poolCache) return Promise.resolve(poolCache);
    var quellen = korb.items.slice(0, 2).map(function (p) {
      return fetch('/recommendations/products.json?product_id=' + p.product_id + '&limit=10&intent=related', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) { return j.products || []; })
        .catch(function () { return []; });
    });
    quellen.push(
      fetch('/collections/lieferbar/products.json?limit=50', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) { return j.products || []; })
        .catch(function () { return []; })
    );
    return Promise.all(quellen).then(function (listen) {
      var alle = [], gesehen = {};
      listen.forEach(function (l) { l.forEach(function (p) { if (p && p.id && !gesehen[p.id]) { gesehen[p.id] = 1; alle.push(p); } }); });
      poolCache = alle;
      return alle;
    });
  }

  function empfLesen(korb) {
    try {
      var s = JSON.parse(w.sessionStorage.getItem(EMPF_KEY) || 'null');
      if (s && s.token === korb.token && Array.isArray(s.wahl) && s.wahl.length) return s.wahl;
    } catch (e) {}
    return null;
  }
  function empfSchreiben(korb, wahl) { try { w.sessionStorage.setItem(EMPF_KEY, JSON.stringify({ token: korb.token, wahl: wahl })); } catch (e) {} }
  function empfVergessen() { try { w.sessionStorage.removeItem(EMPF_KEY); } catch (e) {} }

  /* Alle Stücke aus dem Pool bewerten — beste zuerst */
  function kandidatenBilden(pool, korb, ausschluss) {
    var imKorb = {}, groessen = [], gruppen = [], marken = [];
    korb.items.forEach(function (p) {
      imKorb[p.product_id] = 1;
      var g = korbGroesse(p); if (g && groessen.indexOf(g) < 0) groessen.push(g);
      gruppen.push(gruppeVon(p.product_type, p.product_title));
      if (p.vendor) marken.push(String(p.vendor).toLowerCase());
    });
    return pool.map(function (p) {
      if (imKorb[p.id] || ausschluss[p.id]) return null;
      var varianten = (p.variants || []).filter(function (v) { return v.available !== false; });
      if (!varianten.length) return null;
      var passende = varianten.filter(function (v) { return [v.option1, v.option2, v.option3].some(function (o) { var g = groesseVon(o); return g && groessen.indexOf(g) > -1; }); });
      var variante = passende[0] || varianten[0];
      var punkte = 0;
      if (passende.length) punkte += 4;
      else if (groessen.length) punkte -= 3;
      var gr = gruppeVon(p.product_type || p.type, p.title);
      if (gruppen.indexOf(gr) < 0) punkte += 3; else punkte -= 1;
      if (p.vendor && marken.indexOf(String(p.vendor).toLowerCase()) > -1) punkte += 1;
      var preis = typeof variante.price === 'number' ? variante.price : Math.round(parseFloat(variante.price) * 100);
      var bild = (p.featured_image) || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
      var groesse = null;
      [variante.option1, variante.option2, variante.option3].forEach(function (o) { groesse = groesse || groesseVon(o); });
      return { id: p.id, handle: p.handle, title: p.title, url: p.url || ('/products/' + p.handle), vid: variante.id, punkte: punkte, preis: preis, bild: bild, groesse: groesse };
    }).filter(Boolean).sort(function (a, b) { return b.punkte - a.punkte || (b.id - a.id); });
  }

  /* Im Pool ohne lieferbare Variante = verkauft. Nicht im Pool = unbekannt, bleibt. */
  function nochLieferbar(pool, id) {
    for (var i = 0; i < pool.length; i++) {
      if (pool[i].id === id) return (pool[i].variants || []).some(function (v) { return v.available !== false; });
    }
    return true;
  }

  function empfehlungenLaden(neu) {
    var raeume = $$('[data-korb-empfehlungen]');
    if (!raeume.length || !T.empfAn) return;
    if (empfLaeuft && !neu) return;
    var vorlage = letzterKorb ? Promise.resolve(letzterKorb) : korbLaden();
    empfLaeuft = true;
    vorlage.then(function (korb) {
      letzterKorb = korb;
      if (!korb.item_count) { empfVergessen(); raeume.forEach(function (r) { r.hidden = true; r.innerHTML = ''; }); empfLaeuft = false; return; }
      return poolLaden(korb).then(function (pool) {
        var anzahl = Math.min(4, Math.max(1, parseInt(T.empfAnzahl, 10) || 2));
        var wahl = empfLesen(korb);
        if (wahl) {
          var behalten = wahl.filter(function (k) { return nochLieferbar(pool, k.id); });
          if (behalten.length < wahl.length) {
            var aus = {}; behalten.forEach(function (k) { aus[k.id] = 1; });
            behalten = behalten.concat(kandidatenBilden(pool, korb, aus).slice(0, wahl.length - behalten.length));
            empfSchreiben(korb, behalten);
            wahl = behalten;
          }
        } else {
          wahl = kandidatenBilden(pool, korb, {}).slice(0, anzahl);
          empfSchreiben(korb, wahl);
        }
        var imKorb = {}; korb.items.forEach(function (p) { imKorb[p.product_id] = 1; });
        var zeigen = wahl.filter(function (k) { return !imKorb[k.id]; });
        if (!zeigen.length) { raeume.forEach(function (r) { r.hidden = true; r.innerHTML = ''; }); empfLaeuft = false; return; }
        var markup =
          '<p class="empf__titel">' + schuetzen(T.empfTitel) + '</p>' +
          (T.empfText ? '<p class="empf__text">' + schuetzen(T.empfText) + '</p>' : '') +
          '<div class="empf__liste">' + zeigen.map(function (k, i) {
            var bild = k.bild ? '<img class="empf__bild" src="' + schuetzen(k.bild) + (String(k.bild).indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" width="56" height="70" loading="lazy">' : '<span class="empf__bild"></span>';
            return '<div class="empf__stueck" style="--i:' + i + '">' +
              '<a href="' + schuetzen(k.url) + '">' + bild + '</a>' +
              '<div><a class="empf__name" href="' + schuetzen(k.url) + '">' + schuetzen(k.title) + '</a>' +
                '<p class="empf__meta">' + (k.groesse ? schuetzen(T.gr) + ' ' + schuetzen(k.groesse) + ' · ' : '') + geld(k.preis) + '</p></div>' +
              '<button class="empf__knopf" type="button" data-empf-hinzu="' + k.vid + '" data-empf-produkt="' + k.id + '">' + schuetzen(T.hinzu) + '</button>' +
            '</div>';
          }).join('') + '</div>';
        raeume.forEach(function (r) { r.hidden = false; r.innerHTML = markup; });
        empfLaeuft = false;
      });
    }).catch(function () { empfLaeuft = false; });
  }

  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-empf-hinzu]');
    if (!b) return;
    e.preventDefault();
    b.classList.add('laedt'); b.disabled = true;
    holen('/cart/add.js', { items: [{ id: parseInt(b.getAttribute('data-empf-hinzu'), 10), quantity: 1 }] })
      .then(function (j) {
        if (j && j.status && j.status >= 400) throw new Error(j.description || 'Fehler');
        b.classList.remove('laedt'); b.classList.add('ist-drin'); b.textContent = T.hinzugefuegt;
        /* kurz „Hinzugefügt“ zeigen, dann Korb neu zeichnen — das Stück verlässt die Liste, nichts rückt nach */
        return new Promise(function (ok) { w.setTimeout(ok, 650); }).then(korbLaden);
      })
      .then(function (korb) { zeichnen(korb, true); })
      .catch(function (err) {
        b.classList.remove('laedt'); b.disabled = false;
        melden(err.message === 'Fehler' ? T.fehler : err.message);
        /* Verkauft in der Zwischenzeit: dieses Stück aus der Merkliste nehmen, einmal ersetzen */
        var pid = parseInt(b.getAttribute('data-empf-produkt'), 10);
        if (pid && letzterKorb) {
          var wahl = empfLesen(letzterKorb);
          if (wahl) { empfSchreiben(letzterKorb, wahl.filter(function (k) { return k.id !== pid; })); poolCache = null; empfehlungenLaden(true); }
        }
      });
  });

  /* ========================================================================
     10 — MELDUNG
     ======================================================================== */
  var meldeUhr = null;
  function melden(text) {
    var el = d.getElementById('meldung');
    if (!el) return;
    el.textContent = text;
    el.classList.add('auf');
    w.clearTimeout(meldeUhr);
    meldeUhr = w.setTimeout(function () { el.classList.remove('auf'); }, 3200);
  }
  w.beuteMelden = melden;

  /* ========================================================================
     11 — PRODUKTSEITE: Größe wählen, Preis/Rabatt nachziehen
     ======================================================================== */
  d.addEventListener('click', function (e) {
    var b = e.target.closest('button[data-groesse]');
    if (!b || b.disabled) return;
    var wurzel = b.closest('[data-produkt]') || d;
    $$('button[data-groesse]', wurzel).forEach(function (o) {
      o.classList.toggle('groesse--gewaehlt', o === b);
      o.setAttribute('aria-pressed', o === b ? 'true' : 'false');
    });
    var id = wurzel.querySelector('[data-varianten-id]');
    if (id) id.value = b.dataset.vid;
    var preis = wurzel.querySelector('[data-preis]');
    if (preis) preis.textContent = b.dataset.price;
    var vorher = wurzel.querySelector('[data-vorher]');
    var rabatt = wurzel.querySelector('[data-rabatt]');
    if (vorher) { vorher.textContent = b.dataset.cmp || ''; vorher.hidden = !b.dataset.cmp; }
    if (rabatt) { rabatt.textContent = b.dataset.pct ? '−' + b.dataset.pct + ' %' : ''; rabatt.hidden = !b.dataset.pct; }
  });

  /* ========================================================================
     12 — KOLLEKTION: Filtern und Sortieren (URL-Parameter bleiben), Größe merken
     ======================================================================== */
  function kollektionStarten(wurzel) {
    if (wurzel.dataset.filterBereit === '1') return;
    wurzel.dataset.filterBereit = '1';
    var grid = wurzel.querySelector('[data-produkt-raster]');
    var leer = wurzel.querySelector('[data-leer]');
    var hinweis = wurzel.querySelector('[data-groesse-hinweis]');
    var anzahlen = $$('[data-anzahl]', wurzel);
    if (!grid) return;
    var params = new URLSearchParams(w.location.search);
    var aktiv = { brand: params.get('filter_brand') || '*', size: params.get('filter_size') || '*' };
    var automatisch = false;

    /* Ohne Filter in der Adresse: gemerkte Größe anwenden — sichtbar, mit Ausweg */
    var gemerkt = meineGroesse();
    if (aktiv.size === '*' && gemerkt && wurzel.dataset.groesseAuto === '1' && wurzel.querySelector('[data-f="size"][data-v="' + gemerkt + '"]')) {
      aktiv.size = gemerkt; automatisch = true;
    }

    function chipsSetzen() {
      $$('[data-f]', wurzel).forEach(function (c) { c.classList.toggle('ist-aktiv', aktiv[c.dataset.f] === c.dataset.v); });
      if (hinweis) {
        hinweis.hidden = !(automatisch && aktiv.size !== '*');
        if (!hinweis.hidden) hinweis.innerHTML = schuetzen(T.grHinweis) + ' <strong>' + schuetzen(aktiv.size) + '</strong> · <a href="#" data-groesse-aufheben>' + schuetzen(T.grAendern) + '</a>';
      }
    }
    function urlSetzen(ersetzen) {
      var url = new URL(w.location.href);
      if (aktiv.brand !== '*') url.searchParams.set('filter_brand', aktiv.brand); else url.searchParams.delete('filter_brand');
      if (aktiv.size !== '*' && !automatisch) url.searchParams.set('filter_size', aktiv.size); else url.searchParams.delete('filter_size');
      if (ersetzen) history.replaceState(null, '', url.toString());
      return url;
    }
    function anwenden() {
      var n = 0;
      Array.prototype.forEach.call(grid.children, function (item) {
        var bOk = aktiv.brand === '*' || (item.dataset.brand || '') === aktiv.brand;
        var sOk = aktiv.size === '*' || (item.dataset.sizes || '').indexOf('|' + aktiv.size + '|') > -1;
        var zeigen = bOk && sOk;
        item.hidden = !zeigen;
        if (zeigen) n++;
      });
      if (leer) leer.hidden = n !== 0;
      anzahlen.forEach(function (a) { a.textContent = n; });
    }
    wurzel.addEventListener('click', function (e) {
      var auf = e.target.closest('[data-groesse-aufheben]');
      if (auf) { e.preventDefault(); aktiv.size = '*'; automatisch = false; groesseMerken(''); chipsSetzen(); urlSetzen(true); anwenden(); return; }
      var c = e.target.closest('[data-f]');
      if (!c) return;
      e.preventDefault();
      aktiv[c.dataset.f] = c.dataset.v;
      if (c.dataset.f === 'size') { automatisch = false; if (c.dataset.v !== '*') groesseMerken(c.dataset.v); }
      chipsSetzen(); urlSetzen(true); anwenden();
    });
    Array.prototype.forEach.call(wurzel.querySelectorAll('input[name="sort_by"]'), function (r) {
      r.addEventListener('change', function () {
        var url = urlSetzen(false);
        url.searchParams.set('sort_by', r.value);
        w.location.href = url.toString();
      });
    });
    var zuruecksetzen = wurzel.querySelector('[data-filter-reset]');
    if (zuruecksetzen) zuruecksetzen.addEventListener('click', function () {
      aktiv.brand = '*'; aktiv.size = '*'; automatisch = false;
      chipsSetzen(); urlSetzen(true); anwenden();
    });
    chipsSetzen(); anwenden();
  }

  d.addEventListener('click', function (e) {
    var k = e.target.closest('[data-filter-ziel]');
    if (!k) return;
    var ziel = d.getElementById(k.getAttribute('data-filter-ziel'));
    if (!ziel) return;
    w.setTimeout(function () { ziel.scrollIntoView({ block: 'start', behavior: 'auto' }); }, 80);
  });

  /* ========================================================================
     12b — EXTERNES VIDEO (YouTube/Vimeo) erst nach Klick laden
     ======================================================================== */
  d.addEventListener('click', function (e) {
    var k = e.target.closest('[data-video-extern]');
    if (!k) return;
    e.preventDefault();
    var f = d.createElement('iframe');
    f.src = k.getAttribute('data-video-extern');
    f.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
    f.setAttribute('allowfullscreen', '');
    f.setAttribute('title', k.getAttribute('aria-label') || 'Video');
    f.className = 'video__iframe';
    k.parentNode.replaceChild(f, k);
  });

  /* ========================================================================
     12c — VIDEO: Quelle nach Bildschirm (bis 720 px am Handy, bis 1080 px am PC),
     Poster steht sofort; ohne JS bleibt das Foto darunter
     ======================================================================== */
  function videoQuelleSetzen(v) {
    if (v.dataset.videoBereit === '1') return;
    v.dataset.videoBereit = '1';
    var klein = v.getAttribute('data-src-klein'), gross = v.getAttribute('data-src-gross');
    var handy = w.innerWidth < 990;
    if (handy && v.getAttribute('data-video-handy') === 'nein') { v.remove(); return; }
    var src = (!handy && gross) ? gross : (klein || gross);
    if (!src) return;
    function start() {
      /* Handy-Fassung ist abgeleitet: gibt es sie nicht, einmal auf die große zurückfallen */
      if (src !== gross && gross) v.addEventListener('error', function () { v.src = gross; var p2 = v.play(); if (p2 && p2.catch) p2.catch(function () {}); }, { once: true });
      v.src = src;
      if (v.hasAttribute('autoplay') && !reduziert) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    }
    if (reduziert) { v.removeAttribute('autoplay'); v.src = src; return; }
    /* Am Handy erst nach dem Seitenladen — das Foto steht sofort, das Video kommt hinterher */
    if (handy && d.readyState !== 'complete') w.addEventListener('load', function () { w.setTimeout(start, 300); }, { once: true });
    else start();
  }

  /* ========================================================================
     12d — LOOK: Produktpunkte öffnen eine Karte, Klick daneben oder Escape schließt
     ======================================================================== */
  function lookZu(dot) {
    dot.setAttribute('aria-expanded', 'false');
    var k = d.getElementById(dot.getAttribute('aria-controls'));
    if (k) k.hidden = true;
  }
  d.addEventListener('click', function (e) {
    var dot = e.target.closest('.look__dot');
    if (!dot) {
      if (!e.target.closest('.look__karte')) $$('.look__dot[aria-expanded="true"]').forEach(lookZu);
      return;
    }
    e.preventDefault();
    var warAuf = dot.getAttribute('aria-expanded') === 'true';
    $$('.look__dot[aria-expanded="true"]').forEach(lookZu);
    if (warAuf) return;
    dot.setAttribute('aria-expanded', 'true');
    var k = d.getElementById(dot.getAttribute('aria-controls'));
    if (k) k.hidden = false;
  });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') $$('.look__dot[aria-expanded="true"]').forEach(lookZu); });

  /* ========================================================================
     12e — VORHER/NACHHER: der Regler schreibt die Trennposition in --p
     ======================================================================== */
  d.addEventListener('input', function (e) {
    var r = e.target.closest('[data-vergleich]');
    if (!r) return;
    r.parentNode.style.setProperty('--p', r.value + '%');
  });

  /* ========================================================================
     12f — FAKTEN: Zahlen zählen hoch, wenn der Abschnitt ins Bild kommt
     ======================================================================== */
  function faktenStarten(el) {
    if (el.dataset.faktenBereit === '1') return;
    el.dataset.faktenBereit = '1';
    if (el.getAttribute('data-fakten') !== '1' || reduziert) return;
    var zellen = $$('[data-zahl]', el);
    if (!zellen.length) return;
    function zaehlen() {
      zellen.forEach(function (z) {
        var roh = z.getAttribute('data-zahl') || '', m = roh.match(/^(\D*)(\d[\d.]*)(.*)$/);
        if (!m) return;
        var ziel = parseInt(m[2].replace(/\./g, ''), 10), start = null, dauer = 900;
        if (!ziel) return;
        function schritt(t) {
          if (start === null) start = t;
          var a = Math.min(1, (t - start) / dauer); a = 1 - Math.pow(1 - a, 3);
          z.textContent = m[1] + Math.round(ziel * a).toLocaleString('de-DE') + m[3];
          if (a < 1) w.requestAnimationFrame(schritt); else z.textContent = roh;
        }
        w.requestAnimationFrame(schritt);
      });
    }
    if ('IntersectionObserver' in w) {
      var io = new w.IntersectionObserver(function (es) { if (es.some(function (x) { return x.isIntersecting; })) { io.disconnect(); zaehlen(); } }, { threshold: 0.3 });
      io.observe(el);
    } else zaehlen();
  }

  /* ========================================================================
     13 — BILDER sanft aufblenden, sobald sie da sind
     ======================================================================== */
  function bildDa(img) { img.classList.add('bild-da'); }
  function bildFassen(img) {
    if (img.getAttribute('loading') !== 'lazy') return;
    if (img.dataset.bildGefasst === '1') return;
    img.dataset.bildGefasst = '1';
    if (img.complete) { bildDa(img); return; }
    img.addEventListener('load', function () { bildDa(img); }, { once: true });
    img.addEventListener('error', function () { bildDa(img); }, { once: true });
  }

  /* ========================================================================
     13b — COUNTDOWN (geschlossener Shop): Ziel „TT.MM.JJJJ HH:MM“ oder ISO-Datum,
     zählt jede Sekunde; abgelaufen → Zahlen weg, Ende-Text sichtbar
     ======================================================================== */
  function zielLesen(text) {
    var t = String(text || '').trim();
    var m = t.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})(?:\D+(\d{1,2})[:.](\d{2}))?$/);
    if (m) return new Date(+m[3], +m[2] - 1, +m[1], m[4] ? +m[4] : 0, m[5] ? +m[5] : 0, 0).getTime();
    var iso = Date.parse(t);
    return isNaN(iso) ? null : iso;
  }
  function countdownStarten(el) {
    if (el.dataset.cdBereit === '1') return;
    el.dataset.cdBereit = '1';
    var ziel = zielLesen(el.getAttribute('data-countdown'));
    var ende = el.parentNode ? el.parentNode.querySelector('[data-cd-ende]') : null;
    var feld = {};
    ['t', 'h', 'm', 's'].forEach(function (k) { feld[k] = el.querySelector('[data-cd="' + k + '"]'); });
    if (ziel == null) { el.hidden = true; return; }
    function zwei(n) { return (n < 10 ? '0' : '') + n; }
    var uhr = null;
    function tick() {
      var rest = ziel - Date.now();
      if (rest <= 0) {
        el.hidden = true; if (ende) ende.hidden = false;
        if (uhr) w.clearInterval(uhr);
        return;
      }
      var s = Math.floor(rest / 1000);
      if (feld.t) feld.t.textContent = zwei(Math.floor(s / 86400));
      if (feld.h) feld.h.textContent = zwei(Math.floor((s % 86400) / 3600));
      if (feld.m) feld.m.textContent = zwei(Math.floor((s % 3600) / 60));
      if (feld.s) feld.s.textContent = zwei(s % 60);
    }
    tick();
    uhr = w.setInterval(tick, 1000);
  }

  /* ========================================================================
     13b — ERSCHEINEN BEIM SCROLLEN (Baukasten 2): [data-erscheint] bekommt .ist-da,
     sobald es zu einem Fünftel im Bild ist — einmal, nie zurück. Ohne Beobachter oder
     bei reduzierter Bewegung sofort sichtbar (CSS nimmt Deckkraft nur mit .js zurück).
     ======================================================================== */
  var erscheinenIO = null;
  function erscheinenStarten(el) {
    if (el.classList.contains('ist-da')) return;
    if (reduziert || !('IntersectionObserver' in w)) { el.classList.add('ist-da'); return; }
    if (!erscheinenIO) {
      erscheinenIO = new w.IntersectionObserver(function (es) {
        es.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('ist-da'); erscheinenIO.unobserve(x.target); } });
      }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
    }
    var r = el.getBoundingClientRect();
    if (r.top < w.innerHeight && r.bottom > 0) { el.classList.add('ist-da'); return; }
    erscheinenIO.observe(el);
  }

  /* ========================================================================
     13c — ANKÜNDIGUNG IM WECHSEL: alle N Sekunden gleitet die Zeile nach oben hinaus,
     die nächste kommt von unten. Pausiert beim Zeigen, Berühren, Fokus, Hintergrund-Tab.
     Bei reduzierter Bewegung harter Wechsel (CSS nimmt die Übergänge weg).
     ======================================================================== */
  function ankWechselStarten(el) {
    if (el.dataset.ankBereit === '1') return;
    el.dataset.ankBereit = '1';
    var zeilen = $$('.ank__zeile', el);
    if (zeilen.length < 2) return;
    var takt = Math.max(2000, (parseInt(el.getAttribute('data-sekunden') || '4', 10) || 4) * 1000);
    var i = 0, pausiert = false;
    ['pointerenter', 'touchstart', 'focusin'].forEach(function (ev) { el.addEventListener(ev, function () { pausiert = true; }, { passive: true }); });
    ['pointerleave', 'touchend', 'touchcancel', 'focusout'].forEach(function (ev) { el.addEventListener(ev, function () { pausiert = false; }, { passive: true }); });
    w.setInterval(function () {
      if (pausiert || d.hidden) return;
      var alt = zeilen[i]; i = (i + 1) % zeilen.length; var neu = zeilen[i];
      alt.classList.remove('ist-da'); alt.classList.add('ist-raus');
      w.setTimeout(function () { alt.classList.remove('ist-raus'); }, 220);
      neu.classList.add('ist-da');
    }, takt);
  }

  /* ========================================================================
     13d — LAUFBAND OHNE LÜCKE: die Spur wird mit Kopien der ersten Gruppe aufgefüllt, bis sie
     den Behälter zweimal deckt; der Animationsschritt ist genau eine Gruppenbreite (px), das
     Tempo bei data-tempo in px/s. Nach Größenänderung neu gemessen.
     ======================================================================== */
  function laufbandFuellen(spur) {
    var gruppen = $$('.ank__gruppe, .laufband__gruppe', spur);
    if (!gruppen.length) return;
    var breite = gruppen[0].getBoundingClientRect().width;
    var behaelter = spur.parentNode ? spur.parentNode.clientWidth : w.innerWidth;
    if (!breite || !behaelter) return;
    var n = 0;
    while (spur.scrollWidth < behaelter * 2 + breite && n < 30) {
      var kopie = gruppen[0].cloneNode(true);
      kopie.setAttribute('aria-hidden', 'true');
      spur.appendChild(kopie); n++;
    }
    spur.style.setProperty('--schritt', breite.toFixed(2) + 'px');
    var tempo = parseFloat(spur.getAttribute('data-tempo') || '0');
    if (tempo > 0) spur.style.setProperty('--lauf', (breite / tempo).toFixed(2) + 's');
  }
  w.addEventListener('resize', drossel(function () { $$('[data-laufband]').forEach(laufbandFuellen); }));

  /* ========================================================================
     13e — NEWSLETTER-POPUP: nach N Sekunden, nach X % Scrollen oder beim Verlassen mit der Maus (PC),
     was zuerst kommt. Einmal je Sitzung, nach Schließen N Tage Pause (localStorage), nach Anmeldung nie.
     Nicht, solange eine Schicht (Menü/Suche/Warenkorb) offen ist. Escape und Schleier schließen.
     Im Editor nur auf Klick auf den Abschnitt.
     ======================================================================== */
  function popupStarten(el) {
    if (el.dataset.nlpBereit === '1') return;
    el.dataset.nlpBereit = '1';
    var KEY = 'beute_nlp';
    var lasche = d.querySelector('[data-nlp-lasche]');
    var karte = el.querySelector('.nlp__karte');
    var feld = el.querySelector('.nlp__feld');
    var form = el.querySelector('form');
    var jetzt = Date.now();
    function lesen() { try { return JSON.parse(w.localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } }
    function merken(o) { try { w.localStorage.setItem(KEY, JSON.stringify(Object.assign(lesen(), o))); } catch (e) { /* privat */ } }
    var stand = lesen();
    var pauseMs = (parseInt(el.getAttribute('data-pause') || '7', 10) || 7) * 86400000;
    var fertig = !!stand.fertig;
    var pausiert = stand.zu && (jetzt - stand.zu) < pauseMs;
    var gesendet = false;
    try { gesendet = w.sessionStorage.getItem('beute_nlp_gesendet') === '1'; } catch (e) { /* privat */ }
    var istAntwort = /customer_posted=true/.test(w.location.search) && (w.location.hash === '#nlp-form' || gesendet);
    var offenNlp = false, letzter = null;

    function oeffnen(ausloeser) {
      if (offenNlp) return;
      if (offen) return; /* Menü, Suche oder Warenkorb offen — nicht dazwischenfunken */
      offenNlp = true;
      letzter = ausloeser || d.activeElement;
      el.hidden = false; void el.offsetWidth; el.classList.add('auf'); el.classList.remove('zu');
      d.body.classList.add('nlp-offen');
      if (lasche) lasche.hidden = true;
      w.setTimeout(function () { var f = el.querySelector('[data-nlp-fertig] .knopf') || feld; if (f) f.focus({ preventScroll: true }); }, 60);
      try { w.sessionStorage.setItem('beute_nlp_gezeigt', '1'); } catch (e) { /* privat */ }
    }
    function schliessen() {
      if (!offenNlp) return;
      offenNlp = false;
      el.classList.add('zu'); el.classList.remove('auf');
      d.body.classList.remove('nlp-offen');
      w.setTimeout(function () { el.hidden = true; el.classList.remove('zu'); }, reduziert ? 0 : 170);
      if (!el.querySelector('[data-nlp-fertig]')) { merken({ zu: Date.now() }); if (lasche) lasche.hidden = false; }
      if (letzter && letzter.focus) letzter.focus({ preventScroll: true });
    }
    $$('[data-nlp-zu]', el).forEach(function (k) { k.addEventListener('click', schliessen); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && offenNlp) schliessen(); });
    /* Fokus bleibt in der Karte */
    el.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !offenNlp) return;
      var f = $$('a[href], button:not([disabled]), input:not([disabled])', karte).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var erstes = f[0], letztes = f[f.length - 1];
      if (e.shiftKey && d.activeElement === erstes) { e.preventDefault(); letztes.focus(); }
      else if (!e.shiftKey && d.activeElement === letztes) { e.preventDefault(); erstes.focus(); }
    });
    if (form) form.addEventListener('submit', function () { try { w.sessionStorage.setItem('beute_nlp_gesendet', '1'); } catch (e) { /* privat */ } });
    if (lasche) lasche.addEventListener('click', function () { oeffnen(lasche); });

    /* Antwort nach dem Absenden: Erfolg → merken und zeigen; Fehler → zeigen */
    if (istAntwort) {
      try { w.sessionStorage.removeItem('beute_nlp_gesendet'); } catch (e) { /* privat */ }
      if (el.querySelector('[data-nlp-fertig]')) { merken({ fertig: 1 }); fertig = true; }
      oeffnen(); return;
    }
    if (el.querySelector('[data-nlp-fehler]') && gesendet) { oeffnen(); return; }
    if (fertig) return;

    if (el.hasAttribute('data-editor')) {
      d.addEventListener('shopify:section:select', function (e) { if (e.target && e.target.contains(el)) oeffnen(); });
      d.addEventListener('shopify:section:deselect', function (e) { if (e.target && e.target.contains(el)) schliessen(); });
      return;
    }
    if (pausiert) { if (lasche) lasche.hidden = false; return; }
    var schonGezeigt = false;
    try { schonGezeigt = w.sessionStorage.getItem('beute_nlp_gezeigt') === '1'; } catch (e) { /* privat */ }
    if (schonGezeigt) { if (lasche) lasche.hidden = false; return; }

    var sek = Math.max(3, parseInt(el.getAttribute('data-sekunden') || '10', 10) || 10);
    var scrollAb = parseInt(el.getAttribute('data-scroll') || '0', 10) || 0;
    var exit = el.getAttribute('data-exit') === 'true';
    var start = Date.now(), ausgeloest = false;
    function ausloesen() { if (ausgeloest) return; ausgeloest = true; oeffnen(); }
    w.setTimeout(ausloesen, sek * 1000);
    if (scrollAb > 0) {
      w.addEventListener('scroll', drossel(function () {
        var h = d.documentElement.scrollHeight - w.innerHeight; if (h <= 0) return;
        if (w.scrollY / h * 100 >= scrollAb && Date.now() - start > 2000) ausloesen();
      }), { passive: true });
    }
    if (exit && w.matchMedia('(pointer:fine)').matches) {
      d.addEventListener('mouseleave', function (e) { if (e.clientY <= 0 && Date.now() - start > 3000) ausloesen(); });
    }
  }

  /* ========================================================================
     14 — START (auch nach Neuaufbau einer Sektion im Theme-Editor)
     ======================================================================== */
  function starten(wurzel) {
    wurzel = wurzel || d;
    $$('img[loading="lazy"]', wurzel).forEach(bildFassen);
    $$('[data-karussell]', wurzel).forEach(karussellStarten);
    $$('[data-countdown]', wurzel).forEach(countdownStarten);
    $$('[data-kollektion]', wurzel).forEach(kollektionStarten);
    $$('video[data-video-quellen]', wurzel).forEach(videoQuelleSetzen);
    $$('[data-fakten]', wurzel).forEach(faktenStarten);
    $$('[data-erscheint]', wurzel).forEach(erscheinenStarten);
    $$('[data-ank-wechsel]', wurzel).forEach(ankWechselStarten);
    $$('[data-laufband]', wurzel).forEach(laufbandFuellen);
    $$('[data-nlp]', wurzel).forEach(popupStarten);
    groessenAnwenden();
  }
  starten();

  if ('MutationObserver' in w) {
    new w.MutationObserver(function (eintraege) {
      var neue = [];
      eintraege.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes, function (k) {
          if (!k || k.nodeType !== 1) return;
          if (k.tagName === 'IMG') { neue.push(k); return; }
          if (!k.querySelectorAll) return;
          var innen = k.querySelectorAll('img[loading="lazy"]');
          if (innen.length) Array.prototype.push.apply(neue, Array.prototype.slice.call(innen));
        });
      });
      neue.forEach(bildFassen);
    }).observe(d.body, { childList: true, subtree: true });
  }

  d.addEventListener('shopify:section:load', function (e) { starten(e.target); });
  d.addEventListener('shopify:section:unload', function () { if (offen) schichtSchliessen(true); });
  d.addEventListener('shopify:block:select', function (e) {
    if (!e.target || !e.target.closest) return;
    var panel = e.target.closest('[data-reiter-panel]');
    if (panel && panel.hidden) {
      var knopf = d.querySelector('[data-reiter="' + panel.getAttribute('data-reiter-panel') + '"]');
      if (knopf) reiterWaehlen(knopf, true);
    }
    var stueck = e.target.closest('.karussell__stueck, .hero__slide');
    if (stueck && stueck.scrollIntoView) stueck.scrollIntoView({ inline: 'start', block: 'nearest', behavior: 'auto' });
    /* Ankündigung: die im Editor angeklickte Zeile zeigen */
    var zeile = e.target.closest('.ank__zeile');
    if (zeile) { $$('.ank__zeile', zeile.parentNode).forEach(function (z) { z.classList.remove('ist-da', 'ist-raus'); }); zeile.classList.add('ist-da'); }
  });

  if (reduziert) {
    $$('video[autoplay]').forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); });
  }

  /* Kopf über dem Auftakt: durchsichtig, solange das Bild unter ihm liegt — dann deckend */
  (function kopfSchweben() {
    var wrap = d.querySelector('[data-kopf].kopf-wrap--schwebt');
    if (!wrap) return;
    /* Erste SICHTBARE Sektion: leere Wrapper (Sektion ohne Blöcke) werden übersprungen. Trägt sie ein
       randloses Bild ([data-hero]), liegt der Kopf durchsichtig darauf — egal welche Sektion das ist. */
    function auftaktErkennen() {
      var main = d.getElementById('MainContent');
      $$('.ist-oben', main || d).forEach(function (x) { x.classList.remove('ist-oben'); });
      var hero = null;
      if (main) {
        var kinder = Array.prototype.slice.call(main.children);
        for (var i = 0; i < kinder.length; i++) {
          var k = kinder[i];
          if (!k.classList || !k.classList.contains('shopify-section')) continue;
          var h = k.querySelector('[data-hero]');
          if (h) { hero = h; break; }
          if (k.offsetHeight > 0 || k.textContent.trim().length) break;
        }
      }
      d.body.classList.toggle('hat-auftakt', !!hero);
      if (hero) hero.classList.add('ist-oben');
      return hero;
    }
    var hero = auftaktErkennen();
    function stand() {
      var fest = !hero || hero.getBoundingClientRect().bottom <= wrap.offsetHeight + 8;
      wrap.classList.toggle('ist-fest', fest);
    }
    function neu() { hero = auftaktErkennen(); stand(); }
    w.addEventListener('scroll', stand, { passive: true });
    w.addEventListener('resize', drossel(stand));
    w.addEventListener('load', neu);
    ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder', 'shopify:section:select'].forEach(function (ev) {
      d.addEventListener(ev, function () { w.setTimeout(neu, 60); });
    });
    stand();
  })();

  /* Rückgabe: Bestellnummer aus der Adresse vorbelegen (?bestellung=1042) */
  (function rueckgabeVorbelegen() {
    var feld = d.getElementById('rueck-nr');
    if (!feld || feld.value) return;
    var nr = new URLSearchParams(w.location.search).get('bestellung');
    if (nr) feld.value = nr.charAt(0) === '#' ? nr : '#' + nr;
  })();

  /* Warenkorbseite: Empfehlungen sofort füllen (in der Schublade erst beim Öffnen) */
  if (d.body.classList.contains('template-cart') && $$('[data-korb-empfehlungen]').length) empfehlungenLaden(true);

})();
